// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/KioskQuantityPicker/style.css
// module id = 2040
// module chunks = 0